import { Role, RoleContext } from '../../setting/expert/expert.const';

const default_avt = 'assets/images/contact.png';
export const getDisplayGroupColumn = (data, groups) => {
  const group = groups.find(g => g.id === parseInt(data.groupId));
  return data.groupId ? (group ? group.name : '') : '';
};
export const getDisplayNameColumn = (data, agents) => {
  const agent = agents.find(
    g => g.email === data.username || g.phone === data.username || g.agent_id === data.username
  );
  const displayName = agent ? (agent.name ? agent.name : '(Không xác định)') : '(Không xác định)';
  const avatars = data.avatar ? data.avatar : agent ? (agent.avatar ? agent.avatar : default_avt) : default_avt;
  return `<img class="img-circle avatar avatar-sm" src="${avatars}" alt="${displayName}"> ${displayName}`;
};
export const getName = (data, agents) => {
  const agent = agents.find(
    g => g.email === data.username || g.phone === data.username || g.agent_id === data.username
  );
  return agent ? (agent.name ? agent.name : '') : '';
};
export const getDisplayUserNameColumn = (data, agents) => {
  const agent = agents.find(g => g._id === data.agentId);
  return data.username
    ? data.username
    : agent
      ? agent.email
        ? agent.email
        : agent.phone
          ? agent.phone
          : agent.agent_id
            ? agent.agent_id
            : ''
      : '';
};
export const getDisplayRoleColumn = (data, user, agents) => {
  if (data.agentId == user.agent_id) return `<small class="badge badge-default">Là bạn</small>`;
  if (!data.role) {
    const agent = agents.find(g => g.agent_id == data.agentId);
    if (agent) {
      data.role = agent.role;
    }
    return '';
  }
  switch (data.role) {
    case Role.Agent:
      return `<small class="badge badge-primary">` + RoleContext.Agent + `</small>`;
    case Role.Supervisor:
      return `<small class="badge badge-info">` + RoleContext.Supervisor + `</small>`;
    case Role.Administrator:
      return `<small class="badge badge-warning">` + RoleContext.Administrator + `</small>`;
    case Role.TeamLeader:
      return `<small class="badge badge-success">` + RoleContext.TeamLeader + `</small>`;
  }
};
export const getDisplaySystemStatusColumn = data => {
  if (data.systemStatus === 'AVAILABLE' || data.statusType) {
    return `<span class="btn btn-primary">Available</span>`;
  } else {
    return `<span class="btn btn-default">Unavailable</span>`;
  }
};

export const getOptions = data => {
  let options = {
    label: '',
    labelBtn: '',
  };
  switch (data) {
    case 'AVAILABLE':
      options.label = `btn-success`;
      options.labelBtn = `btn-outline-success`;
      break;
    case 'NOACD':
      options.label = `btn-warning`;
      options.labelBtn = `btn-outline-warning`;
      break;
    case 'NOT AVAILABLE':
      options.label = `btn-danger`;
      options.labelBtn = `btn-outline-danger`;
      break;
    case 'ONCAMPAIGN':
      options.label = `btn-info`;
      options.labelBtn = `btn-outline-info`;
      break;
    default:
      options.label = `btn-default`;
      options.labelBtn = `btn-outline-default`;
      break;
  }
  return options;
};
export const getPhoneOptions = data => {
  let options = {
    label: '',
    labelBtn: '',
  };
  switch (data) {
    case '0':
    case 0:
      options.label = `btn-success`;
      options.labelBtn = `btn-outline-success`;
      break;
    case '3':
    case 3:
      options.label = `btn-warning`;
      options.labelBtn = `btn-outline-warning`;
      break;
    case '1':
    case 1:
    case '2':
    case 2:
      options.label = `btn-info`;
      options.labelBtn = `btn-outline-info`;
      break;
    default:
      options.label = `btn-default`;
      options.labelBtn = `btn-outline-default`;
      break;
  }
  return options;
};
export const getArray = level => {
  let arr = [];
  if (level === 3) arr.push({ id: '-1', text: 'Chọn' });
  arr = [
    ...arr,
    { id: 'AVAILABLE', text: 'Sẵn sàng làm việc' },
    { id: 'NOT AVAILABLE', text: 'Không sẵn sàng làm việc' },
  ];
  if (level >= 2) {
    arr = [...arr, { id: 'NOACD', text: 'Sẵn sàng NoACD' }];
  }
  if (level >= 1) {
    arr = [
      ...arr,
      { id: 'ONCAMPAIGN', text: 'Thực hiện chiến dịch' },
      { id: 'TYPING', text: 'Typing' },
      { id: 'ATLUNCH', text: 'Ăn trưa' },
      { id: 'MEETING', text: 'Đi họp' },
      { id: 'TRAINING', text: 'Đào tạo' },
      { id: 'GOOUT', text: 'Đi ra ngoài' },
    ];
    if (level < 3) {
      arr = [...arr, { id: 'LOGOUT', text: 'Đăng xuất' }];
    }
  }
  return arr;
};
export const displayStatusColumn = (status, statusList) => {
  const options = getOptions(status);
  return {
    text: statusList.find(st => st.id == status).text || 'Không xác định',
    ...options,
  };
};
export const displayPhoneTypeColumn = (type, data) => {
  const options = getPhoneOptions(type);
  const yData = data.find(st => st.id == type) || {};
  return {
    text: yData.text || 'Không xác định',
    ...options,
  };
};



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/agents/agents.const.ts